import { observer } from 'mobx-react-lite';
import { ModalOption } from '@client/stores/modalStore';
import DocViewer from '../DocViewer';
import { Modal } from './Modal';

const GuideModal = observer(({ modalId, option }: { modalId: string; option: ModalOption }) => {
    return (
        <Modal.Dialog modalId={modalId}>
            <Modal.BodyScroll>
                <DocViewer docKey={option.guide?.docKey || ''} />
            </Modal.BodyScroll>
        </Modal.Dialog>
    );
});

export default GuideModal;
